import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * RFC for scrolling to top when header navigation is triggered
 * @returns null
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
